import React from "react";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import { Helmet } from "react-helmet";
import "../../../../styles/Pages/Financial/CashInFlow/Others/Others.style.css";
import OtherThingsAsGrants from "../../../../components/PagesComponents/Financial/CashInFlow/Others/OtherThingsAsGrants.component";

const Body = () => {
  return (
    <section className="cashInFlowOthers">
      <Helmet>
        <title>Fees</title>
        <meta
          name="description"
          content="A powerful organization management system to streamline workflows and improve efficiency."
        />
        <meta
          name="keywords"
          content="organization management, workflow automation, business management, employee tracking"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader
        title={"Fees"}
        renderCustomElement={
          <button className="blueActionBtnLight toggleActionBtn">
            <input type="checkbox" />{" "}
            <span className="box">All other grants collection</span>
          </button>
        }
      />
      <div className="GrantBox mt-2">
        <OtherThingsAsGrants />
      </div>
    </section>
  );
};

export default Body;
